import React, { useState, useEffect } from "react";
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Model from './components/Model';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import * as Sentry from '@sentry/react';

const App = () => {
  const [ theme,setTheme] = useState("light");
  const isMobileBySize = (threshold = 640) =>{
      // 检查是否在浏览器环境中
      if (typeof window === 'undefined') {
          throw new Error('此函数需在浏览器环境中运行');
      }
      
      // 获取当前视口宽度（包含滚动条）
      const viewportWidth = window.innerWidth;
      
      // 小于等于阈值则视为手机设备
      return viewportWidth <= threshold;
  }
  useEffect(() => {
    setTheme("light");
  }, []);
  return (
    <main className={theme === "dark" ? "bg-black text-white" : "bg-light text-black"}>
      <Navbar theme={theme} isMobile={isMobileBySize()} setTheme={setTheme} />
      <div className="bg-light dark:bg-black transition-colors duration-1000" style={{height:'100%',maxWidth:'100%'}}>
          <Hero theme={theme} setTheme={setTheme} isMobile={isMobileBySize()} />
          <HowItWorks theme={theme} setTheme={setTheme} isMobile={isMobileBySize()} />
          {/* <Highlights theme={theme} setTheme={setTheme} isMobile={isMobileBySize()} /> */}
          <Model theme={theme} setTheme={setTheme} isMobile={isMobileBySize()} />
          
          {/* <Features theme={theme} setTheme={setTheme} /> */}
      </div>
      <Footer theme={theme} setTheme={setTheme} isMobile={isMobileBySize()} />
    </main>
  );
};

export default Sentry.withProfiler(App);